import type { ApiResponse } from './types';
import routes from '@/config/routes';
import { v3Get } from '@/api/axios.instance.V3';

const getClientList = (): ApiResponse => v3Get(routes.backendUrl.client.get);
const getClientById = (clientId: number): ApiResponse => v3Get(`${routes.backendUrl.client.getById}${clientId}`);

export const clientApi = {
  getClientList,
  getClientById,
};
